import FacteurEmissionCo2Controller from './facteur-emission-co2.controller';

export default {
    template: require('./facteur-emission-co2.tpl.html'),
    controller: FacteurEmissionCo2Controller
};
